import React from "react";
import Representation from "./Representation";

const TeachAI = (props) => <Representation {...props} />;

export default TeachAI;
